export default function BondingLiquidHowToUse() {
  const steps = [
    {
      number: "1",
      title: "Clean and dampen the surface",
      description: "Ensure the surface is free from dust, grease, and loose material. Dampen thoroughly with clean water."
    },
    {
      number: "2",
      title: "Dilute or apply neat depending on application",
      description: "For general use, dilute with water as per instructions. For maximum bonding, apply neat directly to the surface."
    },
    {
      number: "3",
      title: "Apply plaster, screed or adhesive while still tacky",
      description: "Work while the bonding liquid is still tacky to ensure optimal adhesion. Do not allow to dry completely."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <h2 className="text-4xl font-bold text-center mb-16 font-['Montserrat']">
          How to Use
        </h2>

        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((step) => (
            <div key={step.number} className="text-center space-y-4">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#F2C612] text-black text-3xl font-bold font-['Montserrat'] mb-4">
                {step.number}
              </div>
              <h3 className="text-xl font-bold font-['Montserrat']">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}